"use client"

import { useEffect } from "react"

/**
 * A page in another language than the site's English root: says so to
 * crawlers that read content-language (Bing among them) and sets the html
 * element's lang once the page runs, for screen readers and translators.
 */
export function PageLanguage({ lang }: { lang: string }) {
  useEffect(() => {
    const root = document.documentElement
    const was = root.lang
    root.lang = lang
    return () => {
      root.lang = was
    }
  }, [lang])
  return <meta httpEquiv="content-language" content={lang} />
}
